import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { GapDocState, GapSpecialtyBreakdown } from "../api/encounters";
import {
  GapHint,
  MISSING_STATES,
  SOURCE_DESCRIPTIONS,
  STATE_BAR_COLORS,
  STATE_DESCRIPTIONS,
  STATE_LABELS,
} from "./gapInfo";

export function SpecialtyGapPanel({
  branch,
  onDrill,
}: {
  branch: GapSpecialtyBreakdown;
  onDrill: (docKey: string, state: GapDocState) => void;
}) {
  return (
    <div className="space-y-3 p-4">
      <p className="text-sm text-muted-foreground">
        {branch.received} received encounters · {branch.providerId}
      </p>
      {branch.docs.map((doc) => {
        const total = branch.received || 1;
        return (
          <div key={doc.key} className="space-y-1">
            <div className="flex items-center justify-between text-sm">
              <span className="font-medium">
                {doc.key}
                {doc.isOneOfGroup ? " (one of)" : ""} ·{" "}
                <GapHint description={SOURCE_DESCRIPTIONS[doc.source]}>
                  <span className="text-muted-foreground">{doc.source}</span>
                </GapHint>
              </span>
              <span className="text-muted-foreground">
                <GapHint description={STATE_DESCRIPTIONS.present}>{doc.counts.present} present</GapHint>
              </span>
            </div>
            <div className="flex h-2 w-full overflow-hidden rounded bg-muted">
              <div className="bg-emerald-500" style={{ width: `${(doc.counts.present / total) * 100}%` }} />
              {MISSING_STATES.map((state) => (
                <div
                  key={state}
                  className={STATE_BAR_COLORS[state]}
                  style={{ width: `${(doc.counts[state] / total) * 100}%` }}
                />
              ))}
            </div>
            <TooltipProvider>
              <div className="flex flex-wrap gap-3 text-xs">
                {MISSING_STATES.filter((s) => doc.counts[s] > 0).map((state) => (
                  <Tooltip key={state}>
                    <TooltipTrigger asChild>
                      <button
                        type="button"
                        className="text-muted-foreground underline-offset-2 hover:underline"
                        aria-label={`${doc.key} — ${STATE_LABELS[state]}: ${doc.counts[state]}`}
                        onClick={() => onDrill(doc.key, state)}
                      >
                        {STATE_LABELS[state]}: {doc.counts[state]}
                      </button>
                    </TooltipTrigger>
                    <TooltipContent side="top" className="max-w-xs">
                      {STATE_DESCRIPTIONS[state]}
                    </TooltipContent>
                  </Tooltip>
                ))}
              </div>
            </TooltipProvider>
          </div>
        );
      })}
    </div>
  );
}
